<template>
	<div>
		<v-dialog v-model="dialog_filter_quarter" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>
                        Select Quarter
                        <v-spacer></v-spacer>
                        <v-menu>
                            <div slot="activator" class="subtitle-text dark-opacity-color" cursor-pointer>
                                FY <span v-if="selectedFiscalYear">{{selectedFiscalYear.toString().substring(2)}}-{{(selectedFiscalYear+1).toString().substring(2)}}</span>
                                <v-icon class="subtitle-icon">arrow_drop_down</v-icon>
                            </div>

                            <v-list dense nopadding>
                                <template v-for="(item, index) in fiscalYears">
                                    <v-list-tile @click="selectedFiscalYear=item.value" :key="index" v-if="fn_checkOpeningDate(item.value)">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{item.title}}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                    </v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

		        	<v-alert type="info" :value="true">Showing quarters between opening date and end of this fiscal year!</v-alert>

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredQuarters" :key="index" @click="selectPeriod('quarterly', item.month, selectedFiscalYear)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{ item.name }} {{item.month > 3 ? selectedFiscalYear : (selectedFiscalYear + 1)}}</v-list-tile-title>
				            </v-list-tile-content>

				            <!-- <v-list-tile-action>
						        <v-icon v-if="item.month == selectedMonth">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action> -->

			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['selectPeriod'],
		data(){
			return{
				dialog_filter_quarter:false,
                selectedFiscalYear:null,
                fiscalYears:[
                    // {"title":"FY 2021", "value":2021},
                    // {"title":"FY 2022", "value":2022}
                    {"title":"FY 22-23", "value":2022},
                    {"title":"FY 23-24", "value":2023},
                    {"title":"FY 24-25", "value":2024},
                    {"title":"FY 25-26", "value":2025},
                    {"title":"FY 26-27", "value":2026}
                ],
				quarters:[
					{"name":"Q1 - Apr To June", "quarter":1, "month":6},
					{"name":"Q2 - Jul To Sep", "quarter":2, "month":9},
					{"name":"Q3 - Oct To Dec", "quarter":3, "month":12},
					{"name":"Q4 - Jan To Mar", "quarter":4, "month":3}
				]
			}
		},
		methods:{
			// openDialogWeb: function () {
            //     let currentDate = new Date();
            //     let currentYear = currentDate.getFullYear();

            //     let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            //     let openingYear = openingDate.getFullYear();
            //     let openingMonth = openingDate.getMonth() + 1;

            //     if(openingMonth<=3 && currentYear <= openingYear){
            //         this.selectedFiscalYear = openingYear - 1;
            //     }
            //     else{
            //         this.selectedFiscalYear = openingYear;
            //     }
                
			// 	this.dialog_filter_quarter = true;
			// },
            openDialogWeb: function () {
                let maxYear = new Date(this.$root.maxDateSelection).getFullYear();

                let currentDate = new Date();
                let currentYear = currentDate.getFullYear() > maxYear ? maxYear : currentDate.getFullYear();
                let currentMonth = currentDate.getMonth() + 1;

                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingYear = openingDate.getFullYear();
                let openingMonth = openingDate.getMonth() + 1;

                let openingFY = openingMonth <= 3 ? (openingYear - 1) : openingYear;
                let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

                this.selectedFiscalYear = currentFY > openingFY ? currentFY : openingFY;

                this.dialog_filter_quarter = true;
            },
			closeDialogWeb: function () {
				this.dialog_filter_quarter = false;
			},
            fn_closeDialog: function(){
				if(this.$parent.fn_closeDialog){
					this.$parent.fn_closeDialog();
				}
				else{
					this.closeDialogWeb();
				}
			},
			fn_checkOpeningDate: function(item){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                if(item >= openingYear){
                    return true;
                }
                else{
                    return false;
                }
            },
		},
		computed:{
			filteredQuarters: function(){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                let items = this.quarters.filter(item=>{
                    // if(openingYear == 2022){
                    //     return item.year == 2022;
                    // }
                    // else{
                    //     return item.month >= openingMonth || item.month <= 3;
                    // }

                    if(openingYear == this.selectedFiscalYear){
                        if(openingMonth <= 3){
                            return item.month <= 3 ? true : false;
                        }
                        else{
                            return item.month >= openingMonth || item.month <= 3 ? true : false;
                        }
                    }
                    else if(openingYear < this.selectedFiscalYear){
                        return item.month;
                    }
                });
                return items;
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_filter_quarter.vue